import { useEffect, useRef } from 'react';

import { PlanType } from '@showbie-socrative/socrative-utils';
import { useAtomValue } from 'jotai';

import { clearAiQuota } from '~shared/stores/aiQuotaStore';
import { selectedTeamIdAtom } from '~teacher/components/Account/atoms';
import { useSelectedTeamQuery } from '~teacher/components/Account/hooks';
import { useTeams } from '~teacher/hook/team';

const FREE_PLANS = [PlanType.Free, PlanType.FreeLegacy];

export function useCurrentPlan() {
  const selectedTeamId = useAtomValue(selectedTeamIdAtom);
  const selectedTeam = useSelectedTeamQuery();
  const currentPlanQuery = useTeams({
    select: (teams) => {
      const team = teams.find((t) => `${t.id}` === `${selectedTeamId}`);
      return team?.subscription?.plan ?? PlanType.Free;
    },
    enabled: !!selectedTeamId && !!selectedTeam.data,
  });

  const previousPlanRef = useRef<PlanType | undefined>(currentPlanQuery.data);

  useEffect(() => {
    const currentPlan = currentPlanQuery.data;
    const previousPlan = previousPlanRef.current;

    // Clear quota when user upgrades from free to paid plan
    if (
      previousPlan !== undefined &&
      currentPlan !== undefined &&
      previousPlan !== currentPlan &&
      FREE_PLANS.includes(previousPlan) &&
      !FREE_PLANS.includes(currentPlan)
    ) {
      clearAiQuota();
    }

    previousPlanRef.current = currentPlan;
  }, [currentPlanQuery.data]);

  return currentPlanQuery;
}
